// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "./app.css";

import { Toaster } from "./components/toast";

import Landing from "./screens/landing/Home";
import OurWhy from "./screens/our-why/our-why";
import CompleteProfile from "./screens/complete-profile/complete-profile";
import Contact from "./screens/contact/Contact";
import Active from "./screens/active/Active";
import Chat from "./screens/chat/Chat";
import Past from "./screens/past/Past";
import { CommunityHub } from "./screens/community/Community";
import EditProfile from "./screens/edit-profile/edit-profile";
import MobileCaptchaChallenge from "./screens/mobile-captcha-challenge/mobile-captcha-challenge";
import Settings from "./screens/settings/Settings";
import PrivacyChoices from "./screens/privacy-choices/privacy-choices";
import DeleteAccount from "./screens/delete-account/delete-account";
import Support from "./screens/support/support";
import ChildSafety from "./screens/child-safety/child-safety";
import OpsConsole from "./screens/ops-console/ops-console";
import {
  AuthedRoute,
  IncompleteProfileRoute,
  LegalPage,
  ProtectedAuthLayout,
  PublicLayout,
} from "./App.function";

/* ----------------------------
   ROOT APP ROUTES
----------------------------- */
export default function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        {/* Public routes share the public navigation and never require auth. */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/our-why" element={<OurWhy />} />
          <Route path="/mobile-captcha" element={<MobileCaptchaChallenge />} />
          <Route path="/terms-of-service" element={<LegalPage documentKey="termsOfService" />} />
          <Route path="/privacy-policy" element={<LegalPage documentKey="privacyPolicy" />} />
          <Route path="/privacy-choices" element={<PrivacyChoices />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/support" element={<Support />} />
          {/* /child-safety.html is the exact URL registered with Google Play (and in
              the prelaunch sitemap) — render the page there directly so the address
              bar keeps the registered URL. The extensionless path is an alias. */}
          <Route path="/child-safety.html" element={<ChildSafety />} />
          <Route path="/child-safety" element={<ChildSafety />} />
          {/* Prelaunch-era link; the waitlist site served the policy at /privacy. */}
          <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
          <Route
            path="/community-guidelines"
            element={<LegalPage documentKey="communityGuidelines" />}
          />
          <Route path="/cookie-policy" element={<LegalPage documentKey="cookiePolicy" />} />
        </Route>

        {/* Protected routes pass through one auth boundary, then branch by profile state. */}
        <Route element={<ProtectedAuthLayout />}>
          <Route element={<IncompleteProfileRoute />}>
            <Route path="/profile" element={<CompleteProfile />} />
          </Route>

          <Route element={<AuthedRoute />}>
            <Route path="/active" element={<Active />} />
            <Route path="/active/chat" element={<Navigate to="/active" replace />} />
            <Route path="/active/chat/:username" element={<Chat />} />
            <Route path="/past" element={<Past />} />
            <Route path="/past/chat/:username" element={<Chat />} />
            <Route path="/ping" element={<Navigate to="/connect" replace />} />
            <Route path="/connect" element={<CommunityHub />} />
            <Route path="/community" element={<Navigate to="/connect" replace />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/console" element={<OpsConsole />} />
            <Route path="/console/reports" element={<Navigate to="/console" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/active" replace />} />
          </Route>

          <Route path="/" element={<Navigate to="/active" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
